import script from "./ChatDrawerItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatDrawerItem.vue?vue&type=script&setup=true&lang=js"

import "./ChatDrawerItem.vue?vue&type=style&index=0&id=d78952d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d78952d6"]])

export default __exports__